import { render } from "./autofill-address.vue?vue&type=template&id=8d6fd676&scoped=true"
import script from "./autofill-address.vue?vue&type=script&lang=js"
export * from "./autofill-address.vue?vue&type=script&lang=js"

import "./autofill-address.vue?vue&type=style&index=0&id=8d6fd676&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6fd676"]])

export default __exports__